import React, { useState } from "react";
import CounterUpComponent from "../components/CounterUpComponent";

const Sectionfour = () => {
  const [openIndex, setOpenIndex] = useState(0);

  const faqs = [
    {
      q: "What if I join and realize Myprega isn't the right fit for me?",
      a: "We are so confident in the transformation we bring that we offer a 30-Day, 90% Money-Back Guarantee. If you don't feel supported, organized, and cared for within your first month, we will refund your money—no questions asked, no awkward conversations."
    },
    {
      q: "I have a demanding career. Will daily tracking and engagement take up too much of my time?",
      a: "Not at all. Myprega was built specifically for busy professionals. Updating your daily vitals on our app takes less than two minutes. Instead of wasting hours in hospital waiting rooms, your entire care team is instantly accessible on your phone, saving you immense time and energy."
    },
    {
      q: "Does Myprega replace my local hospital? Does Myprega handle the actual delivery, or do I need to find a hospital later?",
      a: "We are your dedicated medical command center for the crucial 270 days leading up to birth. We give you complete flexibility and control. When your big day arrives, our expert gynecologist can absolutely handle your delivery at a hospital of your choice or one of our highly recommended partner hospitals. Alternatively, if you already have a preferred delivering doctor or maternity hospital in mind, you can seamlessly transition to them. You will arrive fully prepared, healthy, and armed with a perfectly organized digital medical file that your delivering doctor will love."
    },
    {
      q: "Can Myprega handle high-risk pregnancies or complications?",
      a: "Yes, absolutely. In fact, our proactive model is built to prevent and manage risks. With daily AI-driven vitals tracking and a cohesive team of 9 specialists, including nutritionists and mental health experts, we catch early warning signs of conditions like gestational diabetes or hypertension much faster than a standard monthly clinic visit."
    },
    {
      q: "How is the 9-expert medical team assigned to me?",
      a: "The moment you onboard, our system and senior medical directors analyze your unique health profile, medical history, current trimester, and exact location. We then hand-pick a synchronized team of specialists, from obstetricians to lactation consultants, who are the absolute best fit for your specific journey. To ensure ultimate convenience, we guarantee that your assigned Myprega gynecologist and sonography center will be within a 10-minute travel radius from your home."
    },
    {
      q: "Is Myprega entirely online, or will I still have physical clinic visits?",
      a: "We use a seamless hybrid model designed for your absolute convenience. Your entire 9-month journey is managed on our tech platform, and the majority of your care, like daily tracking, personalized nutrition, mental health coaching, and 24/7 expert access, is delivered instantly at your fingertips. However, for essential physical checkups like your in-person gynecologist consultations and ultrasound scans, you will visit our premium Myprega physical setups. Because we match you based on location, these physical visits will never be more than a 10-minute drive away. It is the perfect blend of digital ease and hands-on medical care."
    },
    {
      q: "How do you select and maintain the quality of the 9 medical experts on my team?",
      a: "We have an uncompromising standard for our Pregnancy Crafters. Every medical expert is hand-selected through a rigorous vetting process. We ensure they hold specializations from Tier-1 medical colleges and possess extensive clinical experience. But we don't just look at resumes, we evaluate their empathy, their vision for maternal care, and their passion for supporting mothers. Furthermore, to guarantee a standardized, elite experience for every mom, all our onboarded experts must complete a rigorous 5-step mandatory training program every 3 months. You are always in the safest, most capable hands."
    },
    {
      q: "What is Myprega's approach to normal deliveries versus C-sections?",
      a: "We are fierce advocates for normal deliveries. A major flaw in the traditional system is the high rate of unnecessary C-sections. At Myprega, our entire ecosystem, from personalized nutrition and proactive daily health tracking to live prenatal yoga and pelvic floor preparation, is scientifically designed to strengthen your body for a natural, safe vaginal delivery. We actively work to avoid unnecessary surgical interventions, ensuring a C-section is only ever recommended when it is absolutely medically necessary for the safety of you and your baby."
    }
  ];

  return (
    <div className="section-four-wrapper section-four-padded">
      <section style={{ 
         backgroundImage: 'url("/AnsweredB.png")', 
         width: '100%',
         aspectRatio: '1440 / 925', 
         backgroundSize: '100% 100%', 
         backgroundPosition: 'center',
         backgroundRepeat: 'no-repeat',
         padding: '80px 0',
         position: 'relative',
         opacity: 1, 
         display: 'flex',
         flexDirection: 'column',
         justifyContent: 'center', 
         minHeight: 'auto' 
     }}>
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="journey-title">
              Your Peace of Mind, <span style={{ color: '#e91e63' }}>Answered</span>
            </h2>
            <p className="journey-subtitle mx-auto">
              Choosing the right partner for your pregnancy is a big decision. We believe in absolute transparency, so you can step into our care ecosystem with total confidence.
            </p>
          </div>

          <div className="row align-items-center">
            <div className="col-lg-6">
              <div className="faq-scroll-list">
                {faqs.map((faq, index) => (
                  <div
                    key={index}
                    className={`faq-card ${openIndex === index ? "faq-card-open" : ""}`}
                  >
                    <button 
                      onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                      className={`faq-toggle ${openIndex === index ? "faq-toggle-open" : ""}`}
                    >
                      <span className="faq-question-wrap">
                        <i className={`bi ${openIndex === index ? 'bi-heart-fill' : 'bi-heart'} faq-question-icon`}></i>
                        {faq.q}
                      </span>
                      <i className={`bi ${openIndex === index ? 'bi-chevron-up' : 'bi-chevron-down'}`}></i>
                    </button>
                    {openIndex === index && (
                      <div className="faq-answer">
                        {faq.a}
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>

            <div className="col-lg-6 text-center">
              <img 
                 src="/AnswereS.png" 
                 alt="Care" 
                 className="img-fluid sectionfour-hero-image"
               />
            </div>
          </div>
        </div>
      </section>

     <section 
       className="stats-section-wrapper"
       style={{ 
         backgroundImage: 'url("/NumberupB.png")', 
         backgroundSize: 'cover', 
         backgroundPosition: 'center',
         padding: '120px 0',
         textAlign: 'center',
         position: 'relative'
       }}
     >
       <img src="/Beyondtop.png" className="top-edge" alt="" />
       <div className="container">
         {/* Section Header */}
         <div className="stats-section-header">
           <h3 className="stats-section-title">
             Everyone has a tab open to
           </h3>
           <h3 className="stats-section-title stats-section-title-accent">
             myprega.com
           </h3>
         </div>
     
         <div className="row justify-content-center stats-cards-row">
           <div className="col-auto stats-card-col">
             <div className="stats-card">
               <h2 className="stats-card-number">
                 <CounterUpComponent targetCount={162} duration={3000} />
                 <span className="stats-card-plus">+</span>
               </h2>
               <p className="stats-card-label">Medical expert</p>
             </div>
           </div>
     
           <div className="col-auto stats-card-col">
             <div className="stats-card">
               <h2 className="stats-card-number">
                 <CounterUpComponent targetCount={606} duration={3000} />
                 <span className="stats-card-plus">+</span>
               </h2>
               <p className="stats-card-label">Moms</p>
             </div>
           </div>
     
           <div className="col-auto stats-card-col">
             <div className="stats-card">
               <h2 className="stats-card-number">
                 <CounterUpComponent targetCount={2030} duration={3000} />
                 <span className="stats-card-plus">+</span>
               </h2>
               <p className="stats-card-label">Mom Buddies</p>
             </div>
           </div>
         </div>
       </div>
         <img src="/BeyondbottoM.png" className="bottom-edge" alt="" />
     </section>
    </div>
  );
};

export default Sectionfour;
